import { useRef } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { GuardedRoute } from '../../routes'
import { useRouteGuardContext } from '../../state/routeGuardProvider'
import { AuthenticationRoute } from '../authentication/AuthenticationRouter'
import { SelectDateTimeRangeImportPage } from './pages/selectDateRange'
import { SelectItineraryPage } from './pages/selectItin'
import { SelectTeamPage } from './pages/selectTeam'
import {
    DuplicateContext,
    createDuplicateStore,
} from './state/duplicate.context'

export const guestDupRoutes: AuthenticationRoute[] = [
    {
        path: 'teamselect',
        page: <SelectTeamPage />,
    },
    {
        path: 'itineraryselect',
        page: <SelectItineraryPage />,
    },
    {
        path: 'datetimerangeselect',
        page: <SelectDateTimeRangeImportPage />,
    },
]

export function GuestDupRouter() {
    const location = useLocation()
    const { isAllowed } = useRouteGuardContext()
    const store = useRef(createDuplicateStore()).current

    return (
        <DuplicateContext.Provider value={store}>
            <Routes key={location.pathname} location={location}>
                {guestDupRoutes.map(
                    (route: AuthenticationRoute, index: number) => {
                        if (route.guard) {
                            return (
                                <Route
                                    element={
                                        <GuardedRoute
                                            auth={isAllowed(
                                                route.guardCallbacks
                                            )}
                                            key={index}
                                            to={route.guardPath}
                                        />
                                    }
                                >
                                    <Route
                                        path={`/${route.path}`}
                                        element={route.page}
                                    ></Route>
                                </Route>
                            )
                        }
                        return (
                            <Route
                                key={index}
                                path={`/${route.path}`}
                                element={route.page}
                            />
                        )
                    }
                )}
            </Routes>
        </DuplicateContext.Provider>
    )
}
